/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Vdot_One_LinerInputs */

const en_exp_vdot_one_liner = /** @type {(inputs: Exp_Vdot_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A single number that estimates your current running fitness based on a recent race result.`)
};

const de_exp_vdot_one_liner = /** @type {(inputs: Exp_Vdot_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Kennzahl, die deine aktuelle Lauffitness anhand eines Rennergebnisses schätzt.`)
};

/**
* | output |
* | --- |
* | "A single number that estimates your current running fitness based on a recent race result." |
*
* @param {Exp_Vdot_One_LinerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_vdot_one_liner = /** @type {((inputs?: Exp_Vdot_One_LinerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Vdot_One_LinerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_vdot_one_liner(inputs)
	return de_exp_vdot_one_liner(inputs)
});